/**
 * /tenants/$slug/webhooks — route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import {
  webhooksListSearchSchema,
  type WebhooksListSearch,
} from "@/features/webhooks/schemas";
import { fetchWebhooksList } from "@/features/webhooks/queries";
import { queryKeys } from "@/lib/query-keys";
import { WebhooksListPage } from "@/features/webhooks/pages/webhooks-list-page";

export const Route = createFileRoute("/_authed/tenants/$slug/webhooks/")({
  validateSearch: (raw: Record<string, unknown>): WebhooksListSearch =>
    webhooksListSearchSchema.parse(raw),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.webhooks.list(context.tenant.id),
      queryFn: () => fetchWebhooksList(context.tenant.id, deps.search),
    }),
  component: WebhooksListPage,
});
